import React from 'react'

import Link from '@src/components/common/Link'
import DocumentStatusIndicator from '@src/components/document/DocumentStatusIndicator'
import * as Routes from '@src/logic/routing/routes'
import { Revision } from '@src/types/document'

const DocumentTableTitle: React.FC<{ revision: Revision }> = ({ revision: r }) => {
    return (
        <>
            <DocumentStatusIndicator revision={r} />
            <div className="selectable-content__title">
                <Link to={Routes.projectDocument(r.projectId, r.documentId, r.id)}>{r.name}</Link>
            </div>
        </>
    )
}

export default React.memo(DocumentTableTitle)
